export default "__VITE_ASSET__CdTF8xA2__"